<template>
  <j-modal :title="titleText"
           :width="modalWidth"
           :style="modalStyle"
           :class="'jeecg-online-modal'"
           :visible="visible"
           :confirmLoading="confirmLoading"
           :okButtonProps="{ props: {disabled: disableSubmit} }"
           @ok="handleSubmit"
           @cancel="handleCancel"
           switch-fullscreen
           :destroyOnClose="true">
    <div v-if="(!disableSubmit) && hasOwnButton(1)">
      <a-button @click="openDoor" :class="single?'cust-button-switch-single':'cust-button-switch-many'">
        <a-icon type="fast-backward" />
      </a-button>
    </div>
    <div :class="btnBoxVisible?'show-drawer':'hide-drawer'" v-if="!disableSubmit && hasOwnButton(1)">
      <div class="jeecg-mask-cust" @click="closeDoor"></div>
      <div class="jeecg-drawer-content" :class="btnBoxVisible?'drawer-open':'drawer-close'">
        <div class="jeecg-drawer-header">自定义按钮</div>
        <div class="jeecg-drawer-body">
          <template v-for="btn in cgButtonList">
            <a-button
              v-if="btn.optPosition == '1'"
              :key="btn.id"
              type="primary"
              :icon="btn.buttonIcon"
              block
              @click="handleCgButtonClick(btn.optType,btn.buttonCode)">
              {{ btn.buttonName }}
            </a-button>
          </template>
        </div>
      </div>
    </div>
    <a-spin :spinning="confirmLoading">
      <online-form ref="onlineForm"
                   :mainData="mainData"
                   @onSuccess="handleSuccess"
                   :formSchema="schema"
                   :uiSchema="uiSchema"
                   :single="single"
                   :tree="treeForm"
                   :enhanceStr="enhanceStr" />
    </a-spin>
    <template slot="footer">
      <template v-if="!disableSubmit && hasOwnButton(2)" v-for="btn in cgButtonList">
        <a-button v-if="btn.optPosition == '2'"
                  :key="btn.id"
                  type="primary"
                  :icon="btn.buttonIcon"
                  @click="handleCgButtonClick(btn.optType,btn.buttonCode)">
          {{ btn.buttonName }}
        </a-button>
      </template>
      <mtc-button key="back" @click="handleCancel" text="button.close" style="margin-right: 8px" />
      <mtc-button v-if="!disableSubmit" key="submit" type="primary" @click="handleSubmit" :loading="submitLoading" text="button.confirm" />
    </template>
  </j-modal>
</template>

<script>
import OnlineForm from '@/components/online/autoform/OnlineFormSwitch'
import { getAction } from '@/api/manage'
import { getLanguageField } from '@/utils/langUtils'

const singleWidth = 800
const one2ManyWidth = 1100
export default {
  name: 'OnlCgformAutoModal',
  components: {
    OnlineForm
  },
  provide() {
    return {
      // 数据多语言字段
      langFieldData: () => this.langField
    }
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      disableSubmit: false,
      titleText: '',
      optMethod: 'post',
      url: {
        loadFormItems: '/online/cgform/api/getFormItem/',
        loadEnhanceJs: '/online/cgform/api/getEnhanceJs/',
        optPre: '/online/cgform/api/form/'
      },
      schema: {},
      uiSchema: {
        itemattrs: ''
      },
      single: true,
      treeForm: false,
      enhanceStr: '',
      modalStyle: { 'position': 'relative' },
      cgButtonList: [],
      btnBoxVisible: false,
      btnBoxVisible2: false,
      submitLoading: false,
      // 数据多语言字段
      langField: []
    }
  },
  props: {
    code: {
      type: String,
      required: true,
      default: ''
    },
    // 当嵌套在主表下的时候，主表的数据，如病案表详情中新增诊断记录功能
    mainData: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    modalWidth() {
      let formTemplate = 1
      if (this.uiSchema.formTemplate) {
        try {
          formTemplate = Number.parseInt(this.uiSchema.formTemplate)
        } catch {
          console.warn('error formTemplate value: ', this.uiSchema.formTemplate)
        }
      }
      // 不同的列数展示不同的宽度
      let diff = 200 * (formTemplate - 1)
      // 基值加上阈值
      let width = (this.single? singleWidth: one2ManyWidth) + diff
      console.log('-- modalWidth: ', width)
      return width
    }
  },
  created() {
    this.loadFormItems()
  },
  watch: {
    code() {
      this.loadFormItems()
    }
  },
  methods: {
    loadFormItems() {
      console.log('this.code', this.code)
      if (!this.code) {
        return
      }
      getAction(`${this.url.loadFormItems}${this.code}`).then((res) => {
        if (res.success) {
          this.single = res.result.head.tableType == 1
          this.schema = res.result.schema
          this.getLangField(this.schema.table)
          this.$emit('schema', this.schema)
          console.log('schema', this.schema)
          this.treeForm = res.result.head.isTree == 'Y'
          this.cgButtonList = (!res.result.cgButtonList)? []: res.result.cgButtonList
          if (res.result.enhanceJs) {
            this.enhanceStr = res.result.enhanceJs
          } else {
            this.enhanceStr = ''
          }
          this.$nextTick(() => {
            if (this.$refs.onlineForm) {
              this.$refs.onlineForm.createRootProperties()
            }
          })
        }
      })
    },
    // 根据表名获取多语言字段
    getLangField(relTable) {
      relTable && getLanguageField(relTable).then(res => {
        this.langField = res.fieldArr
        this.$store.commit('SET_TABLELANGFIELD', this.langField)
      })
    },
    close() {
      this.visible = false
      this.submitLoading = false
    },
    handleSubmit() {
      this.submitLoading = true
      this.$refs.onlineForm.handleSubmit()
      setTimeout(() => {
        this.submitLoading = false
      }, 3500)
    },
    handleSuccess(formdata, arr) {
      this.close()
      if (this.treeForm === true) {
        this.$emit('success', formdata, arr)
      } else {
        this.$emit('success')
      }
    },
    handleCancel() {
      this.close()
    },
    add(formTemplate, param) {
      this.titleText = 'button.add'
      this.uiSchema.method = 'post'
      this.uiSchema.formTemplate = formTemplate
      this.uiSchema.url = this.url.optPre + this.code
      this.uiSchema = { ...this.uiSchema }
      this.showModal()
      this.disableSubmit = false
      this.$nextTick(() => {
        this.$refs.onlineForm.add(param)
      })
    },
    edit(formTemplate, id) {
      this.titleText = 'button.edit'
      this.uiSchema.method = 'put'
      this.uiSchema.formTemplate = formTemplate
      this.uiSchema.url = this.url.optPre + this.code
      this.uiSchema = { ...this.uiSchema }
      this.showModal()
      this.disableSubmit = false
      getAction(this.url.optPre + this.code + '/' + id).then((res) => {
        if (res.success) {
          let record = res.result
          this.$refs.onlineForm.edit(record)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    showModal() {
      this.$store.commit('SET_LANGFIELDMAP', null)
      this.visible = true
    },
    detail(formTemplate, id) {
      this.titleText = this.$t('tip.details')
      this.showModal()
      this.uiSchema.formTemplate = formTemplate
      this.uiSchema = { ...this.uiSchema }
      this.disableSubmit = true
      getAction(this.url.optPre + this.code + '/' + id).then((res) => {
        if (res.success) {
          let record = res.result
          this.$refs.onlineForm.detail(record)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleCgButtonClick(optType, buttonCode) {
      this.$refs.onlineForm.handleCgButtonClick(optType, buttonCode, this.code)
    },
    openDoor() {
      if (this.btnBoxVisible2) {
        setTimeout(() => {
          this.btnBoxVisible2 = !this.btnBoxVisible2
        }, 1000)
      } else {
        this.btnBoxVisible2 = !this.btnBoxVisible2
      }
      this.btnBoxVisible = !this.btnBoxVisible
    },
    closeDoor() {
      this.btnBoxVisible = false
    },
    hasOwnButton(flag) {
      if (!this.cgButtonList || this.cgButtonList.length == 0) {
        return false
      } else {
        let a = this.cgButtonList.filter(item => {
          return item.optPosition == flag
        })
        return a && a.length > 0
      }
    }
  }
}
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.has-error .ant-form-explain, .has-error .ant-form-split {
  color: #f5222d;
  position: absolute;
}


.jeecg-mask-cust {
  height: 0%;
  width: 100%;
  opacity: 0.3;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 999;
}

.jeecg-drawer-content {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10000;
  width: 160px;
  height: 100%;
  overflow: hidden;
  background: #fff;
  transform-origin: 100% 50% 0;
  transition: transform 0.3s, opacity 0.2s;
}

.jeecg-drawer-content.drawer-open {
  opacity: 1;
  transform: scaleX(1);
}

.jeecg-drawer-content.drawer-close {
  opacity: 0;
  transform: scaleX(0);
}

.show-drawer {
  width: 100%;
}

.hide-drawer {
  width: 0;
}

.show-drawer .jeecg-drawer-content {
  height: 100%;
  z-index: 10000;
}

.jeecg-drawer-header {
  padding: 16px;
  border-radius: 4px 4px 0 0;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  color: rgba(0, 0, 0, 0.85);
}

.jeecg-drawer-body {
  padding: 0px 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
  overflow: auto;
  height: calc(100% - 54px);
}

.jeecg-drawer-body .ant-btn {
  margin-top: 12px;
}

.jeecg-drawer-body .ant-btn:last-child {
  margin-bottom: 12px;
}

.show-drawer .jeecg-mask-cust {
  height: 100%;
}

.cust-button-switch-single {
  position: absolute;
  top: 220px;
  right: 0px;
  z-index: 1000;
  cursor: pointer;
  padding: 0 5px;
  font-size: 20px;
}

.cust-button-switch-many {
  position: absolute;
  top: 220px;
  right: 0px;
  z-index: 1000;
  cursor: pointer;
  padding: 0 5px;
  font-size: 20px;
}

.cust-button-switch-single,
.cust-button-switch-many {
  top: 50%;
  border-right: 0;
  border-radius: 4px 0 0 4px;
}

</style>